var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6824 4.76699L5.84078 13.6087C5.23244 12.7837 4.89911 11.7753 4.89911 10.6837V6.75866C4.89911 5.22533 5.58244 3.85033 6.66578 2.91699V6.36699C6.66578 6.69199 6.93244 6.95866 7.24911 6.95866C7.57411 6.95866 7.84078 6.69199 7.84078 6.36699V2.14199C8.22411 1.95033 8.63244 1.81699 9.05744 1.74199V4.79199C9.05744 5.12533 9.32411 5.38366 9.64911 5.38366C9.97411 5.38366 10.2408 5.12533 10.2408 4.79199V1.66699C12.2324 1.75866 13.9491 3.00866 14.6824 4.76699Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1001 7.40234V10.6857C15.1001 13.494 12.8084 15.7857 10.0001 15.7857C9.85011 15.7857 9.70011 15.7773 9.55011 15.7607C9.48344 15.7607 9.41678 15.7523 9.35844 15.744C9.25011 15.7273 9.14178 15.7107 9.04178 15.694C9.00011 15.694 8.96678 15.6773 8.91678 15.669C8.80011 15.644 8.68344 15.6107 8.57511 15.5773C8.39178 15.5273 8.21678 15.4607 8.05011 15.394C7.94178 15.3523 7.84178 15.3107 7.74178 15.2523C7.71678 15.244 7.70011 15.2273 7.67511 15.219C7.59178 15.1773 7.50844 15.1357 7.42511 15.0773L15.1001 7.40234Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1247 9.16699V10.8337C18.1247 15.317 14.4831 18.9587 9.99972 18.9587C8.23305 18.9587 6.54139 18.392 5.14972 17.3503L6.04972 16.4503C7.19972 17.267 8.56639 17.7087 9.99972 17.7087C13.7914 17.7087 16.8747 14.6253 16.8747 10.8337V9.16699C16.8747 8.82533 17.1581 8.54199 17.4997 8.54199C17.8414 8.54199 18.1247 8.82533 18.1247 9.16699Z",
    fill: "#35446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1408 1.86035C17.8908 1.61035 17.4824 1.61035 17.2324 1.86035L1.85742 17.2437C1.60742 17.4937 1.60742 17.902 1.85742 18.152C1.98242 18.2687 2.14076 18.3354 2.30742 18.3354C2.47409 18.3354 2.63242 18.2687 2.75742 18.1437L18.1408 2.76035C18.3991 2.51035 18.3991 2.11035 18.1408 1.86035Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon01);
export default __webpack_public_path__ + "static/media/video-icon-01.9f59800bbdf216d6b72b9a11360fcc82.svg";
export { ForwardRef as ReactComponent };